<div  class="d-flex flex-column position-relative prime-calendar form-input">
    <label  class="justify-content-start d-flex">{{label}}<span *ngIf="mandatory" class="text-danger">*</span></label>
    <div (focusout)="elementFocused()" [ngClass]="{
        'border-danger': isInerrorState
      }">
      <div *ngIf="viewFormat; else elseStatement" class="date-field">
        <p-calendar [maxDate]="maxDateValidation ? currentDate : null" icon="pi pi-custom-calendar" [appendTo]="'body'" [disabled]="isCheckBoxTicked" [(ngModel)]="defaultDate" (ngModelChange)="onSelectedDataChange($event)"  [dateFormat]="dateFormat" 
        [view]="viewFormat" [showTime]="showTime"  [showIcon]="true" styleClass="d-flex align-items-center position-relative w-100 input-field"></p-calendar>
    </div>
    <ng-template #elseStatement>
      <div class="clock-field">
        <p-calendar [appendTo]="'body'" [(ngModel)]="defaultDate" [disabled]="isCheckBoxTicked"   [timeOnly]="timeOnly" (ngModelChange)="onSelectedDataChange($event)" [showTime]="showTime"  [dateFormat]="dateFormat" 
        [showIcon]="true" styleClass="d-flex align-items-center position-relative w-100 input-field"></p-calendar>
      </div>
      </ng-template>
    </div>
    <label class="checkbox mt-2" *ngIf="toShowCheckBox">
      <input type="checkbox"  (click)="CheckAction($event)">
      <span class="d-flex">{{checkBoxMessage}}</span>
    </label>
</div>